import React from 'react';
import { connect } from "react-redux";
import {
    TextField, PrimaryButton, Dialog, DialogType, DatePicker,
    Label, Dropdown, DialogFooter, DefaultButton
} from 'office-ui-fabric-react';
import {
    PATIENT_ASSIGNMENT_LIST,
} from "../../constants/lists";

import { PATIENT_ASSIGNMENT, USER_TYPE } from "../../constants/enums";
import moment from "moment";
import axios from "axios";
import config from "../../config";
import helpers from "../../helpers";

const PAGE_PA_LIST = PATIENT_ASSIGNMENT_LIST.filter(
    (opt) => opt.key !== PATIENT_ASSIGNMENT.DO_NOT_KNOW
);

const HorizontalLine = () => (
    <hr
        style={{
            margin: "20px 0px",
            border: "none",
            borderTop: "1px dashed",
            borderColor: "lightgray",
        }}
    />
);


export class CustomerAddEditForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
            isEditing: true,
            theCustomer: props.theCustomer,
            insurancedoc: null,
            errors: {}
        }
        this.onFileChange = this.onFileChange.bind(this);
        this.handleValidateForm = this.handleValidateForm.bind(this);
    }

    componentDidMount() {

        if (this.props.isCloserPage) {

            this.setState(prevState => ({
                theCustomer: {
                    ...prevState.theCustomer,
                    assignedToCloserId: this.props.auth.user._id || "",
                    assignedToCloserAt: new Date(),
                    assignedToCloserById: this.props.auth.user._id
                }
            }));
        }
    }


    valueChange(key, v) {
        this.setState((prevState) => ({
            theCustomer: { ...(prevState.theCustomer || {}), [key]: v },
        }));
    }


    handleScanClick() {
        this.insurancedoc.click();
    };

    onFileChange(event) {
        let target = event.target;

        this.setState((prevState) => ({
            insurancedoc: target.files
        }));

    };

    save() {

        console.log(this.state.theCustomer);

        const hasError = this.handleValidateForm();

        if (!hasError) {
            let data = this.state.theCustomer;

            const conf = {
                headers: {
                    'content-type': 'multipart/form-data'
                },

            }

            var form_data = new FormData();

            for (var key in data) {
                if (data[key] !== undefined && data[key] !== null)
                    form_data.append(key, data[key]);
            }

            if (this.state.insurancedoc !== undefined && this.state.insurancedoc !== null)
                for (let insurancedoc of this.state.insurancedoc) {
                    form_data.append("insurancedoc", insurancedoc);
                }

            if (data.patientAssignment === PATIENT_ASSIGNMENT.SEND_BACK) {
                this.sendBackToCU(data);
            } else {
                axios
                    .post(`${config.apiUrl}/customer/update`, form_data, conf)
                    .then(({ data }) => {
                        //console.log(data)
                        this.props.refreshCustomerList(data);
                        this.props.closeDialog();
                    })
                    .catch((ex) => {
                        console.error(ex);
                        // alert('Error');
                    });
            }
        }
    }

    handleValidateForm() {
        const {
            firstName,
            lastName,
            birthDate,
            phone,
            address,
            zipCode

        } = this.state.theCustomer;

        let newErrors = {};

        if (!firstName) {
            newErrors = {
                ...newErrors,
                firstName: "Please enter customer firstname",
            };
        }
        if (!lastName) {
            newErrors = {
                ...newErrors,
                lastName: "Please enter customer lastname",
            };
        }

        if (!birthDate) {
            newErrors = {
                ...newErrors,
                birthDate: "Please enter customer date of birth",
            };
        }

        if (!address) {
            newErrors = {
                ...newErrors,
                address: "Please enter customer address",
            };
        }
        if (!phone) {
            newErrors = {
                ...newErrors,
                phone: "Please enter customer phone number",
            };
        } else if (!helpers.validatePhoneNumber(phone)) {
            newErrors = {
                ...newErrors,
                phone: "Phone number is invalid",
            };
        }

        if (!zipCode) {
            newErrors = {
                ...newErrors,
                zipCode: "Please enter customer zipcode",
            };
        }

        if (!_.isEmpty(newErrors)) {
            this.setState({
                errors: newErrors,
            });

            return true;
        }

        return false;
    }

    render() {

        const { showDialog, isEditing, closers, closeDialog } = this.props;
        const { errors } = this.state;

        let theCustomer = this.state.theCustomer;

        var user = this.props.auth.user;
        const isVendor = user.orgType == 'vendor';

        let filenames = "";

        if (this.state.insurancedoc) {

            filenames = this.state.insurancedoc.length + " files chosen...";

        }

        return (<div>
            {
                <Dialog
                    isOpen={showDialog}
                    type={DialogType.normal}
                    onDismiss={() => closeDialog()}
                    title={isEditing ? "Edit" : "Add new customer"}
                    isBlocking={true}
                    containerClassName="relative-info"
                >
                    <div className="ms-Grid">
                        {["admin", "manager", "central-user", "closer", "staff"].includes(
                            _.get(this.props, "auth.user.accountType")
                        ) && (
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-u-md6">
                                        <TextField
                                            className="one-line-150"
                                            label="First Name"
                                            value={theCustomer.firstName}
                                            onChanged={(v) => this.valueChange("firstName", v)}
                                            errorMessage={errors.firstName}
                                        />
                                        <TextField
                                            className="one-line-150"
                                            label="Middle Name"
                                            value={theCustomer.middleName}
                                            onChanged={(v) => this.valueChange("middleName", v)}
                                        />
                                        <TextField
                                            className="one-line-150"
                                            label="Last Name"
                                            value={theCustomer.lastName}
                                            onChanged={(v) => this.valueChange("lastName", v)}
                                            errorMessage={errors.lastName}
                                        />
                                        <DatePicker
                                            className="one-line-150"
                                            label="Birth Date"
                                            value={
                                                theCustomer.birthDate
                                                    ? new Date(theCustomer.birthDate)
                                                    : new Date()
                                            }
                                            onSelectDate={(v) => { this.valueChange("birthDate", v) }}
                                            formatDate={(date) => moment(date).format("MMM DD YYYY")}
                                            errorMessage={errors.birthDate}
                                            allowTextInput
                                        />
                                        <TextField
                                            className="one-line-150"
                                            label="Phone Number"
                                            value={theCustomer.phone}
                                            onChanged={(v) => this.valueChange("phone", v)}
                                            errorMessage={errors.phone}
                                        />
                                    </div>
                                    <div className="ms-Grid-col ms-u-md6">
                                        <TextField
                                            className="one-line-150"
                                            label="Email Address"
                                            value={theCustomer.emailAddress}
                                            onChanged={(v) => this.valueChange("emailAddress", v)}
                                        />
                                        <TextField
                                            className="one-line-150"
                                            label="Address"
                                            value={theCustomer.address}
                                            onChanged={(v) => this.valueChange("address", v)}
                                            errorMessage={errors.address}
                                        />
                                        <TextField
                                            className="one-line-150"
                                            label="City"
                                            value={theCustomer.city}
                                            onChanged={(v) => this.valueChange("city", v)}
                                        />
                                        <TextField
                                            className="one-line-150"
                                            label="State"
                                            value={theCustomer.state}
                                            onChanged={(v) => this.valueChange("state", v)}
                                        />
                                        <TextField
                                            className="one-line-150"
                                            label="Zip code"
                                            value={theCustomer.zipCode}
                                            onChanged={(v) => this.valueChange("zipCode", v)}
                                            errorMessage={errors.zipCode}
                                        />
                                    </div>
                                </div>
                            )}
                        <div>
                            <div className="ms-Grid-row">
                                <div
                                    className="ms-Grid-col ms-u-md12"
                                    style={{ display: "flex", alignItems: "baseline" }}
                                >
                                    <div style={{ marginRight: 10, width: 140 }}>
                                        <Label>Comments</Label>
                                    </div>
                                    <div style={{ width: "calc(100% - 150px)" }}>
                                        <TextField
                                            multiline
                                            rows={2}
                                            placeholder="Enter some comments..."
                                            value={theCustomer.comments}
                                            onChanged={(newValue) => {
                                                this.valueChange("comments", newValue);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <HorizontalLine />
                        {["admin", "manager", "central-user", "closer"].includes(
                            _.get(this.props, "auth.user.accountType")
                        ) && (
                                <div className="ms-Grid-row">
                                    <div
                                        className="ms-Grid-col ms-u-md6"
                                        style={{ display: "flex", alignItems: "center" }}
                                    >
                                        <div
                                            style={{
                                                margin: "0px 10px 10px 0px",
                                                width: 140,
                                                float: "left",
                                            }}
                                        >
                                            <Label>Patient Assignment</Label>
                                        </div>
                                        <div
                                            style={{
                                                width: "calc(100% - 150px)",
                                            }}
                                        >
                                            <Dropdown
                                                selectedKey={theCustomer.patientAssignment}
                                                placeHolder="Select a type..."
                                                options={PAGE_PA_LIST}
                                                onChanged={(opt) =>
                                                    this.valueChange("patientAssignment", opt.key)
                                                }
                                            /*isDisabled={isCloserPage}*/
                                            />
                                        </div>
                                    </div>
                                    {["admin", "manager", "central-user"].includes(
                                        _.get(this.props, "auth.user.accountType")
                                    ) && (
                                            <div
                                                className="ms-Grid-col ms-u-md6"
                                                style={{ display: "flex", alignItems: "center" }}
                                            >
                                                <div
                                                    style={{
                                                        margin: "0px 10px 10px 0px",
                                                        width: 140,
                                                        float: "left",
                                                    }}
                                                >
                                                    <Label>Lead Class</Label>
                                                </div>
                                                <div
                                                    style={{
                                                        width: "calc(100% - 150px)",
                                                    }}
                                                >
                                                    <Dropdown
                                                        selectedKey={theCustomer.leadClass}
                                                        placeHolder="Select a type..."
                                                        options={[{ key: "", text: "All" }, { key: "served", text: "Served" }, { key: "good", text: "Good" }, { key: "bad", text: "Bad" }]}
                                                        onChanged={(opt) =>
                                                            this.valueChange("leadClass", opt.key)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )}



                                    {theCustomer.patientAssignment === PATIENT_ASSIGNMENT.CALL_BACK && (
                                        <div>
                                            <HorizontalLine />
                                            <div className="ms-Grid-row">
                                                <div
                                                    className="ms-Grid-col ms-u-md12"
                                                    style={{ display: "flex", alignItems: "baseline" }}
                                                >
                                                    <div style={{ marginRight: 10, width: 140 }}>
                                                        <Label>{"Closers"}</Label>
                                                    </div>
                                                    <div style={{ width: "calc(100% - 150px)" }}>
                                                        <Dropdown
                                                            label="Closers"
                                                            options={closers}
                                                            selectedKey={theCustomer.assignedToCloserId}
                                                            onChanged={(v) =>
                                                                this.valueChange("assignedToCloserId", v.key)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                    </div>
                    <DialogFooter>

                        {this.state.insurancedoc && (<DefaultButton disabled="true" style={{ backgroundColor: "pink" }}>
                            <Label>{filenames}</Label>
                        </DefaultButton>)}
                        <DefaultButton onClick={() => this.handleScanClick()}>
                            Scan
                        </DefaultButton>

                        <input onChange={this.onFileChange} multiple='true' id="insurancedoc" name="insurancedoc" ref={input => this.insurancedoc = input} type='file' style={{ display: 'none' }} accept='application/pdf' />
                        {!isVendor && (<PrimaryButton
                            onClick={() => this.save()}
                            disabled={
                                theCustomer.patientAssignment ===
                                PATIENT_ASSIGNMENT.SEND_BACK && !theCustomer.comments
                            }
                        >
                            Save
                        </PrimaryButton>)}
                        <DefaultButton onClick={() => closeDialog()}>
                            Cancel
                        </DefaultButton>
                    </DialogFooter>

                </Dialog>}
        </div>
        );
    }
}

function mapStateToProps(state, own_props) {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(CustomerAddEditForm);


// WEBPACK FOOTER //
// ./client/components/common/CustomerAddEditForm.js